import { render, staticRenderFns } from "./NwxFileUploader.vue?vue&type=template&id=bf7764f0&scoped=true"
import script from "./NwxFileUploader.vue?vue&type=script&lang=js"
export * from "./NwxFileUploader.vue?vue&type=script&lang=js"
import style0 from "./NwxFileUploader.vue?vue&type=style&index=0&id=bf7764f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7764f0",
  null
  
)

export default component.exports